// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Ticket Header & Layout ── */
.ticket-header {
  position: relative;
  height: auto;
}

.ticket-info-card {
  top: 0;
  background: var(--color-white);
  border: 1px solid var(--color-border-light);
}

.ticket-info-card .card-body {
  height: auto;
  overflow: visible;
}

.ticket-content {
  height: auto;
  padding-right: 8px;
}

.ticket-divider {
  margin: 10px 0;
  border-top: 1px solid #ccc;
}

/* ── Tabs ── */
.ticket-tab-hdr {
  border-bottom: 2px solid #e5e7eb;
  background: var(--color-white);
  padding: 0 20px 0 0;
}

.ticket-tab {
  padding: 12px 24px;
  background: transparent;
  border: none;
  color: #6b7280;
  font-weight: 700;
  font-size: .9rem;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  font-family: inherit;
}

.ticket-tab:hover {
  color: var(--color-primary-orange);
  background: #fff7ed;
}

.ticket-tab.selected {
  color: var(--color-primary-orange);
  border-bottom-color: var(--color-primary-green);
  font-weight: 700;
}

/* ── Compact form spacing ── */
.form-label {
  font-size: 13px;
  margin-bottom: 4px;
}

.form-control,
select {
  font-size: 13px;
  padding: 4px 6px;
}

/* ── Messages Table ── */
.message-table-header th {
  background: var(--color-bg-hover);
  color: #495057;
  font-weight: 600;
  font-size: 13px;
  border-bottom: 1px solid #dee2e6;
}

.msg-time {
  font-size: 12px;
  color: var(--color-icon-muted);
}

.msg-from {
  font-weight: 600;
  color: var(--color-primary-green);
}

.msg-to {
  font-weight: 600;
  color: #495057;
}

.message-body img {
  max-width: 120px;
  max-height: 120px;
  width: auto;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
  display: block;
  margin: 6px 0;
}

.blur-background {
  filter: blur(4px);
  transition: filter 0.2s ease-in-out;
}

/* ── Quill Wrappers ── */
.quill-wrapper {
  height: 160px;
  width: 100%;
}

.quill-wrapper .ql-toolbar.ql-snow {
  display: block;
  border: 1px solid #ced4da;
  border-bottom: none;
  border-radius: 4px 4px 0 0;
  background: var(--color-white);
  z-index: 1;
}

.quill-wrapper .ql-container.ql-snow {
  height: 120px !important;
  border: 1px solid #ced4da;
  border-radius: 0 0 4px 4px;
  overflow-y: auto;
}

.quill-wrapper .ql-editor {
  height: 120px !important;
  overflow-y: auto;
}

.ticket-quill-wrapper {
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
}

.ticket-quill-wrapper .ql-toolbar.ql-snow {
  border: none;
  border-bottom: 1px solid #ccc;
}

.ticket-quill-wrapper .ql-container.ql-snow {
  border: none !important;
  overflow: hidden !important;
}

.ticket-quill-wrapper .ql-editor {
  min-height: 150px;
  max-height: 500px;
  overflow-y: auto;
  resize: vertical;
}

/* ── Solution ── */
.solution-template-select {
  position: relative;
  z-index: 1055;
  margin-bottom: 10px;
}

.solution-editor .ql-container {
  min-height: 120px;
}

/* ── Send Message Modal ── */
.modal-minimize-btn {
  cursor: pointer;
  font-size: 28px;
  line-height: 1;
  color: #666;
  margin-right: 4px;
  -webkit-user-select: none;
          user-select: none;
}
.modal-minimize-btn:hover { color: #333; }

.modal-close-btn {
  cursor: pointer;
  font-size: 24px;
  line-height: 1;
  color: #666;
  -webkit-user-select: none;
          user-select: none;
}
.modal-close-btn:hover { color: #333; }

.send-message-minimized-bar {
  position: fixed;
  bottom: 0;
  right: 20px;
  width: 280px;
  background: var(--color-primary-orange);
  color: var(--color-white);
  padding: 8px 16px;
  border-radius: 8px 8px 0 0;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1050;
  box-shadow: 0 -2px 8px rgba(0,0,0,0.2);
  font-size: 14px;
}
.send-message-minimized-bar:hover { background: #23272b; }
.send-message-minimized-close { font-size: 18px; line-height: 1; }

.modal-minimized-backdrop .modal-backdrop { display: none !important; }
.modal-minimized-backdrop { overflow: auto !important; padding-right: 0 !important; }

/* ── Icon Buttons (zoom, download etc.) ── */
.icon-btn {
  width: 36px;
  height: 36px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-primary-green);
  border-color: var(--color-primary-green);
}

.icon-btn:hover {
  background-color: var(--color-primary-green);
  border-color: var(--color-primary-green);
}

.icon-btn i { font-size: 14px; }

.icon-btn-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ── Floating Action Button ── */
.floating-action-button {
  position: fixed;
  bottom: 100px;
  right: 40px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 1000;
}

.floating-action-button:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
}

.floating-action-button i { color: var(--color-white); font-size: 24px; }

.floating-button-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #e74c3c;
  color: var(--color-white);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  border: 2px solid var(--color-white);
}

/* ── Side Panel ── */
.side-panel-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
  animation: fadeIn 0.3s ease;
}

.side-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 450px;
  height: 100vh;
  background: var(--color-white);
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  z-index: 1050;
  display: flex;
  flex-direction: column;
  animation: slideInRight 0.3s ease;
}

.side-panel-header {
  padding: 19px 22px;
  background: linear-gradient(135deg,var(--color-primary-green) 0%, var(--color-primary-green) 100%);
  color: var(--color-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.side-panel-header h5 { font-weight: 600; font-size: 18px; }

.close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: var(--color-white);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.close-btn:hover { background: rgba(255, 255, 255, 0.3); transform: scale(1.1); }

.side-panel-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 20px;
}

/* ── Insights ── */
.insight-section { margin-bottom: 16px; }

.insight-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #f0f0f0;
}

.insight-section-header h6 { font-size: 14px; font-weight: 600; color: #333; }

.insight-badge {
  background: var(--color-primary-green);
  color: var(--color-white);
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 12px;
  min-width: 24px;
  text-align: center;
}

.insight-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 16px;
}

.insight-card {
  border: 2px solid #d0d0d0;
  border-radius: 8px;
  transition: all 0.2s ease;
  cursor: pointer;
  background: var(--color-white);
}

.insight-card:hover {
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
  transform: translateY(-2px);
}

.insight-card .card-body { padding: 12px; }

.ticket-link { color: var(--color-primary-green); font-weight: 600; font-size: 13px; text-decoration: none; }
.ticket-link:hover { text-decoration: underline; }
.ticket-date { color: #999; font-size: 11px; }
.ticket-title { font-size: 13px; color: #333; margin-bottom: 8px; font-weight: 500; }
.ticket-meta { display: flex; gap: 12px; font-size: 11px; color: #666; }
.meta-item strong { color: #333; }

.view-more-btn {
  width: 100%;
  padding: 10px;
  background-color: var(--color-bg-hover);
  border: 1px solid #dee2e6;
  border-radius: 6px;
  color:var(--color-primary-green);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}
.view-more-btn:hover { background-color: #e9ecef; border-color:var(--color-primary-green); }
.view-more-btn i { font-size: 12px; }

/* ── Workflow Tabs ── */
.workflow-tab-hdr {
  border-bottom: 2px solid #e5e7eb;
  background: var(--color-white);
  padding: 0 20px 0 0;
}

.workflow-tab {
  width: 233px;
  padding: 10px 20px;
  background: transparent;
  border: none;
  color: #6b7280;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  font-family: inherit;
  display: flex;
}
.workflow-tab:hover { color: var(--color-primary-orange); background: #fff7ed; }
.workflow-tab.selected { color: var(--color-primary-orange); border-bottom-color: var(--color-primary-orange); background-color: #f8e7d8ff; }

.workflow-overflow-dots {
  color:var(--color-primary-orange);
  cursor: pointer;
  font-size: 20px;
  padding: 6px 10px;
  -webkit-user-select: none;
          user-select: none;
  margin-left: -20px;
}
.workflow-overflow-dots:hover { background-color: #fff7ed; }

/* ── Table hover ── */
.table tbody tr { transition: background-color 0.2s ease, box-shadow 0.2s ease; }
.table tbody tr:hover {
  background-color: rgba(255, 127, 14, 0.06);
  box-shadow: inset 4px 0 0 var(--color-primary-orange);
}

/* ── Cell alignment ── */
.cell-center-align { display: flex !important; justify-content: center !important; align-items: center !important; }
.cell-left-align { display: flex !important; justify-content: flex-start !important; align-items: center !important; }

/* ── Custom scrollbar ── */
.custom-scrollbar::-webkit-scrollbar { width: 1px; }
.custom-scrollbar::-webkit-scrollbar-track { background: var(--color-white); }
.custom-scrollbar::-webkit-scrollbar-thumb { background-color: #bdbdbd; border-radius: 10px; }
.custom-scrollbar::-webkit-scrollbar-thumb:hover { background-color: #9e9e9e; }
.custom-scrollbar { scrollbar-width: thin; }

.insight-cards::-webkit-scrollbar { width: 6px; }
.insight-cards::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 10px; }
.insight-cards::-webkit-scrollbar-thumb { background: #888; border-radius: 10px; }
.insight-cards::-webkit-scrollbar-thumb:hover { background: #555; }

/* ── Animations ── */
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes slideInRight { from { transform: translateX(100%); } to { transform: translateX(0); } }

@media (max-width: 768px) {
  .side-panel { width: 100%; }
}
/* ── Internal Notes ── */
.note-section-title {
  font-weight: 600;
  margin-bottom: 0;
}

.note-show-toggle {
  cursor: pointer;
  font-weight: 600;
  color: var(--color-icon-muted);
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.note-toggle-icon {
  font-size: 12px;
}

.note-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 8px;
  position: relative;
}

.note-meta {
  min-width: 160px;
  max-width: 160px;
}

.note-author {
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.note-time {
  font-size: 12px;
  color: var(--color-icon-muted);
}

.note-eye-wrap {
  padding-top: 2px;
  position: relative;
}

.note-eye-icon {
  color: var(--color-primary-orange);
  cursor: pointer;
  font-size: 14px;
}

.note-text-clamp {
  flex: 1 1;
  font-size: 13px;
  color: #212529;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Note Tooltip */
.note-tooltip {
  position: absolute;
  z-index: 1050;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  width: 340px;
  background: #f0fafa;
  border: 1px solid var(--color-primary-green);
  border-left: 4px solid var(--color-primary-green);
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(10, 118, 116, 0.15);
  padding: 16px;
}

.note-tooltip-arrow-border {
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid var(--color-primary-green);
}

.note-tooltip-arrow {
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #f0fafa;
}

.note-tooltip-name {
  font-weight: 700;
  font-size: 15px;
  margin-bottom: 4px;
}

.note-tooltip-date {
  font-size: 12px;
  color: var(--color-icon-muted);
  margin-bottom: 10px;
}

.note-tooltip-divider {
  margin: 8px 0;
}

.note-tooltip-body {
  font-size: 13px;
  color: #212529;
  line-height: 1.6;
  white-space: pre-line;
  word-break: break-word;
}

.note-tooltip-updated {
  font-size: 11px;
  color: #adb5bd;
  margin-top: 10px;
}
.note-table {
  border: 1px solid #495057;
  border-radius: 8px;
  overflow: visible;
}

.note-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 8px;
  position: relative;
  border-bottom: 1px solid #e9ecef;
}

.note-row:first-child {
  border-radius: 8px 8px 0 0;  /* keeps rounded corners on first row */
}

.note-row:last-child {
  border-bottom: none;
  border-radius: 0 0 8px 8px;  /* keeps rounded corners on last row */
}

/* ── CC Recipients Column ── */
.cc-recipients {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.cc-badge {
  transition: all 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
}

.cc-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Responsive: Hide CC column on mobile */
@media (max-width: 768px) {
  .cc-column {
    display: none;
  }
}

/* Tablet: Show CC column but with smaller width */
@media (min-width: 769px) and (max-width: 1024px) {
  th.cc-column,
  td.cc-column {
    width: 140px !important;
  }
}
@media (max-width: 768px) {
  .detailsPageHeader {
    flex-wrap: wrap;
    row-gap: 8px;
  }

  .detailsPageHeader .dropdown-toggle {
    width: 100% !important;
  }

  .detailsPageHeader .dropdown-menu {
    width: 100% !important;
  }

  .detailsPageHeader > .col-md-3 {
    max-width: 100%;
    flex: 1 1 100%;
    order: 2;
  }

  .detailsPageHeader > [class*="gx-0"] {
    flex: 1 1 auto;
    order: 3;
  }

  .detailsPageHeader .default-btn-color {
    width: 100%;
    white-space: nowrap;
  }
}
@media (max-width: 768px) {
  .detailsPageHeader .col.d-flex.justify-content-between {
    flex-direction: column;
    align-items: stretch !important;
    gap: 8px;
  }

  .detailsPageHeader .breadcrumb-wrapper {
    width: 100%;
    order: 1;
  }

  .detailsPageHeader .header-actions {
    width: 100%;
    justify-content: flex-end;
    order: 2;
  }
}
@media (max-width: 768px) {
  .detailsPageHeader {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  .detailsPageHeader .col-auto {
    padding: 0 !important;
  }

  .detailsPageHeader .col-auto .gx-0 {
    margin-right: 6px !important;
    margin-bottom: 6px;
  }

  .detailsPageHeader button,
  .detailsPageHeader .btn {
    margin: 0 4px 6px 0 !important;
  }
}
 .ticket-selected-badge {
  background: var(--primary);
  color: var(--primary-text);
  border-radius: 20px;
  padding: 2px 10px;
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
}
/* ── Orange link icons (SAP/District/Region/Company) ── */
.location-link-icon {
  color: var(--color-primary-green);
  font-size: 14px;
  cursor: pointer;
}

/* ── Store Visit text link ── */
.store-visit-link {
  font-size: 12px;
  color: var(--color-primary-orange);
  cursor: pointer;
  text-decoration: underline;
}

/* ── Employee search external-link round button ── */
.emp-search-btn {
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: var(--color-primary-green);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.avatar-circle {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #0bb5d4;
  color: var(--color-white);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 14px;
  flex-shrink: 0;
}
.message-bubble {
  max-width: 75%;
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}

.message-bubble--me {
  background: #d1f8ff;
  border: 2px solid #0bb5d4;
}

.message-bubble--other {
  background: #f1f1f1;
  border: 2px solid #ddd;
}
.eye-icon {
  color: var(--color-primary-orange);
}

.attachment-badge {
  background-color: rgba(10, 118, 116, 0.12);
  color: var(--color-primary-green);
  font-weight: 600;
  border-radius: 12px;
  padding: 4px 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  white-space: nowrap;
}
.history-table-header {
  color: var(--color-primary-orange);
}
.insight-header-icon {
  color: var(--color-primary-orange);
  font-size: 20px;
}

.insight-close-btn {
  background-color: var(--color-primary-orange);
  color: var(--color-white);
}

.insight-section-icon {
  color: var(--color-primary-orange);
}
.workflow-arrow-icon {
  color: var(--color-primary-orange);
}`, "",{"version":3,"sources":["webpack://./src/containers/ticketing/ticketing/components/Ticketing.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,MAAM;EACN,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,4BAA4B,WAAW,EAAE;;AAEzC;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,yBAAyB,WAAW,EAAE;;AAEtC;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,eAAe;AACjB;AACA,oCAAoC,mBAAmB,EAAE;AACzD,gCAAgC,eAAe,EAAE,cAAc,EAAE;;AAEjE,4CAA4C,wBAAwB,EAAE;AACtE,4BAA4B,yBAAyB,EAAE,2BAA2B,EAAE;;AAEpF,6CAA6C;AAC7C;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA,cAAc,eAAe,EAAE;;AAE/B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;EAC/C,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,4BAA4B,yBAAyB,EAAE,eAAe,EAAE;;AAExE;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,oCAAoC;EACpC,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,kGAAkG;EAClG,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB,gBAAgB,EAAE,eAAe,EAAE;;AAE3D;EACE,oCAAoC;EACpC,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;AACA,mBAAmB,oCAAoC,EAAE,qBAAqB,EAAE;;AAEhF;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB,mBAAmB,mBAAmB,EAAE;;AAExC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,6BAA6B,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;;AAE7E;EACE,sCAAsC;EACtC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,2BAA2B,aAAa,EAAE;;AAE1C,eAAe,iCAAiC,EAAE,gBAAgB,EAAE,eAAe,EAAE,qBAAqB,EAAE;AAC5G,qBAAqB,0BAA0B,EAAE;AACjD,eAAe,WAAW,EAAE,eAAe,EAAE;AAC7C,gBAAgB,eAAe,EAAE,WAAW,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACpF,eAAe,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,WAAW,EAAE;AACvE,oBAAoB,WAAW,EAAE;;AAEjC;EACE,WAAW;EACX,aAAa;EACb,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA,uBAAuB,yBAAyB,EAAE,uCAAuC,EAAE;AAC3F,mBAAmB,eAAe,EAAE;;AAEpC,wBAAwB;AACxB;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,oBAAoB;EACpB,aAAa;AACf;AACA,sBAAsB,kCAAkC,EAAE,mBAAmB,EAAE;AAC/E,yBAAyB,kCAAkC,EAAE,gDAAgD,EAAE,2BAA2B,EAAE;;AAE5I;EACE,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA,gCAAgC,yBAAyB,EAAE;;AAE3D,sBAAsB;AACtB,kBAAkB,4DAA4D,EAAE;AAChF;EACE,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA,yBAAyB;AACzB,qBAAqB,wBAAwB,EAAE,kCAAkC,EAAE,8BAA8B,EAAE;AACnH,mBAAmB,wBAAwB,EAAE,sCAAsC,EAAE,8BAA8B,EAAE;;AAErH,2BAA2B;AAC3B,uCAAuC,UAAU,EAAE;AACnD,6CAA6C,8BAA8B,EAAE;AAC7E,6CAA6C,yBAAyB,EAAE,mBAAmB,EAAE;AAC7F,mDAAmD,yBAAyB,EAAE;AAC9E,oBAAoB,qBAAqB,EAAE;;AAE3C,oCAAoC,UAAU,EAAE;AAChD,0CAA0C,mBAAmB,EAAE,mBAAmB,EAAE;AACpF,0CAA0C,gBAAgB,EAAE,mBAAmB,EAAE;AACjF,gDAAgD,gBAAgB,EAAE;;AAElE,qBAAqB;AACrB,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAC5D,0BAA0B,OAAO,2BAA2B,EAAE,EAAE,KAAK,wBAAwB,EAAE,EAAE;;AAEjG;EACE,cAAc,WAAW,EAAE;AAC7B;AACA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,mBAAmB;EACnB,4CAA4C;EAC5C,iDAAiD;EACjD,mBAAmB;EACnB,+CAA+C;EAC/C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B,GAAG,uCAAuC;AACtE;;AAEA;EACE,mBAAmB;EACnB,0BAA0B,GAAG,sCAAsC;AACrE;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,yCAAyC;AACzC;EACE;IACE,aAAa;EACf;AACF;;AAEA,kDAAkD;AAClD;EACE;;IAEE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,+BAA+B;IAC/B,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,QAAQ;EACV;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;;IAEE,8BAA8B;EAChC;AACF;CACC;EACC,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA,0DAA0D;AAC1D;EACE,iCAAiC;EACjC,eAAe;EACf,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,0BAA0B;AAC5B;;AAEA,qDAAqD;AACrD;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC","sourcesContent":["/* ── Ticket Header & Layout ── */\r\n.ticket-header {\r\n  position: relative;\r\n  height: auto;\r\n}\r\n\r\n.ticket-info-card {\r\n  top: 0;\r\n  background: var(--color-white);\r\n  border: 1px solid var(--color-border-light);\r\n}\r\n\r\n.ticket-info-card .card-body {\r\n  height: auto;\r\n  overflow: visible;\r\n}\r\n\r\n.ticket-content {\r\n  height: auto;\r\n  padding-right: 8px;\r\n}\r\n\r\n.ticket-divider {\r\n  margin: 10px 0;\r\n  border-top: 1px solid #ccc;\r\n}\r\n\r\n/* ── Tabs ── */\r\n.ticket-tab-hdr {\r\n  border-bottom: 2px solid #e5e7eb;\r\n  background: var(--color-white);\r\n  padding: 0 20px 0 0;\r\n}\r\n\r\n.ticket-tab {\r\n  padding: 12px 24px;\r\n  background: transparent;\r\n  border: none;\r\n  color: #6b7280;\r\n  font-weight: 700;\r\n  font-size: .9rem;\r\n  cursor: pointer;\r\n  position: relative;\r\n  transition: all 0.3s ease;\r\n  border-bottom: 3px solid transparent;\r\n  font-family: inherit;\r\n}\r\n\r\n.ticket-tab:hover {\r\n  color: var(--color-primary-orange);\r\n  background: #fff7ed;\r\n}\r\n\r\n.ticket-tab.selected {\r\n  color: var(--color-primary-orange);\r\n  border-bottom-color: var(--color-primary-green);\r\n  font-weight: 700;\r\n}\r\n\r\n/* ── Compact form spacing ── */\r\n.form-label {\r\n  font-size: 13px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.form-control,\r\nselect {\r\n  font-size: 13px;\r\n  padding: 4px 6px;\r\n}\r\n\r\n/* ── Messages Table ── */\r\n.message-table-header th {\r\n  background: var(--color-bg-hover);\r\n  color: #495057;\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  border-bottom: 1px solid #dee2e6;\r\n}\r\n\r\n.msg-time {\r\n  font-size: 12px;\r\n  color: var(--color-icon-muted);\r\n}\r\n\r\n.msg-from {\r\n  font-weight: 600;\r\n  color: var(--color-primary-green);\r\n}\r\n\r\n.msg-to {\r\n  font-weight: 600;\r\n  color: #495057;\r\n}\r\n\r\n.message-body img {\r\n  max-width: 120px;\r\n  max-height: 120px;\r\n  width: auto;\r\n  height: auto;\r\n  object-fit: cover;\r\n  border-radius: 8px;\r\n  display: block;\r\n  margin: 6px 0;\r\n}\r\n\r\n.blur-background {\r\n  filter: blur(4px);\r\n  transition: filter 0.2s ease-in-out;\r\n}\r\n\r\n/* ── Quill Wrappers ── */\r\n.quill-wrapper {\r\n  height: 160px;\r\n  width: 100%;\r\n}\r\n\r\n.quill-wrapper .ql-toolbar.ql-snow {\r\n  display: block;\r\n  border: 1px solid #ced4da;\r\n  border-bottom: none;\r\n  border-radius: 4px 4px 0 0;\r\n  background: var(--color-white);\r\n  z-index: 1;\r\n}\r\n\r\n.quill-wrapper .ql-container.ql-snow {\r\n  height: 120px !important;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 0 0 4px 4px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.quill-wrapper .ql-editor {\r\n  height: 120px !important;\r\n  overflow-y: auto;\r\n}\r\n\r\n.ticket-quill-wrapper {\r\n  border: 1px solid #ccc;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.ticket-quill-wrapper .ql-toolbar.ql-snow {\r\n  border: none;\r\n  border-bottom: 1px solid #ccc;\r\n}\r\n\r\n.ticket-quill-wrapper .ql-container.ql-snow {\r\n  border: none !important;\r\n  overflow: hidden !important;\r\n}\r\n\r\n.ticket-quill-wrapper .ql-editor {\r\n  min-height: 150px;\r\n  max-height: 500px;\r\n  overflow-y: auto;\r\n  resize: vertical;\r\n}\r\n\r\n/* ── Solution ── */\r\n.solution-template-select {\r\n  position: relative;\r\n  z-index: 1055;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.solution-editor .ql-container {\r\n  min-height: 120px;\r\n}\r\n\r\n/* ── Send Message Modal ── */\r\n.modal-minimize-btn {\r\n  cursor: pointer;\r\n  font-size: 28px;\r\n  line-height: 1;\r\n  color: #666;\r\n  margin-right: 4px;\r\n  user-select: none;\r\n}\r\n.modal-minimize-btn:hover { color: #333; }\r\n\r\n.modal-close-btn {\r\n  cursor: pointer;\r\n  font-size: 24px;\r\n  line-height: 1;\r\n  color: #666;\r\n  user-select: none;\r\n}\r\n.modal-close-btn:hover { color: #333; }\r\n\r\n.send-message-minimized-bar {\r\n  position: fixed;\r\n  bottom: 0;\r\n  right: 20px;\r\n  width: 280px;\r\n  background: var(--color-primary-orange);\r\n  color: var(--color-white);\r\n  padding: 8px 16px;\r\n  border-radius: 8px 8px 0 0;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  z-index: 1050;\r\n  box-shadow: 0 -2px 8px rgba(0,0,0,0.2);\r\n  font-size: 14px;\r\n}\r\n.send-message-minimized-bar:hover { background: #23272b; }\r\n.send-message-minimized-close { font-size: 18px; line-height: 1; }\r\n\r\n.modal-minimized-backdrop .modal-backdrop { display: none !important; }\r\n.modal-minimized-backdrop { overflow: auto !important; padding-right: 0 !important; }\r\n\r\n/* ── Icon Buttons (zoom, download etc.) ── */\r\n.icon-btn {\r\n  width: 36px;\r\n  height: 36px;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: var(--color-primary-green);\r\n  border-color: var(--color-primary-green);\r\n}\r\n\r\n.icon-btn:hover {\r\n  background-color: var(--color-primary-green);\r\n  border-color: var(--color-primary-green);\r\n}\r\n\r\n.icon-btn i { font-size: 14px; }\r\n\r\n.icon-btn-group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n/* ── Floating Action Button ── */\r\n.floating-action-button {\r\n  position: fixed;\r\n  bottom: 100px;\r\n  right: 40px;\r\n  width: 60px;\r\n  height: 60px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  border: none;\r\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.3s ease;\r\n  z-index: 1000;\r\n}\r\n\r\n.floating-action-button:hover {\r\n  transform: scale(1.1);\r\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);\r\n}\r\n\r\n.floating-action-button i { color: var(--color-white); font-size: 24px; }\r\n\r\n.floating-button-badge {\r\n  position: absolute;\r\n  top: -5px;\r\n  right: -5px;\r\n  background-color: #e74c3c;\r\n  color: var(--color-white);\r\n  border-radius: 50%;\r\n  width: 24px;\r\n  height: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  border: 2px solid var(--color-white);\r\n}\r\n\r\n/* ── Side Panel ── */\r\n.side-panel-overlay {\r\n  position: fixed;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: 1040;\r\n  animation: fadeIn 0.3s ease;\r\n}\r\n\r\n.side-panel {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  width: 450px;\r\n  height: 100vh;\r\n  background: var(--color-white);\r\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);\r\n  z-index: 1050;\r\n  display: flex;\r\n  flex-direction: column;\r\n  animation: slideInRight 0.3s ease;\r\n}\r\n\r\n.side-panel-header {\r\n  padding: 19px 22px;\r\n  background: linear-gradient(135deg,var(--color-primary-green) 0%, var(--color-primary-green) 100%);\r\n  color: var(--color-white);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.side-panel-header h5 { font-weight: 600; font-size: 18px; }\r\n\r\n.close-btn {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border: none;\r\n  color: var(--color-white);\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n.close-btn:hover { background: rgba(255, 255, 255, 0.3); transform: scale(1.1); }\r\n\r\n.side-panel-content {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 16px 20px;\r\n}\r\n\r\n/* ── Insights ── */\r\n.insight-section { margin-bottom: 16px; }\r\n\r\n.insight-section-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 12px;\r\n  padding-bottom: 8px;\r\n  border-bottom: 2px solid #f0f0f0;\r\n}\r\n\r\n.insight-section-header h6 { font-size: 14px; font-weight: 600; color: #333; }\r\n\r\n.insight-badge {\r\n  background: var(--color-primary-green);\r\n  color: var(--color-white);\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  padding: 4px 10px;\r\n  border-radius: 12px;\r\n  min-width: 24px;\r\n  text-align: center;\r\n}\r\n\r\n.insight-cards {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  padding-top: 16px;\r\n}\r\n\r\n.insight-card {\r\n  border: 2px solid #d0d0d0;\r\n  border-radius: 8px;\r\n  transition: all 0.2s ease;\r\n  cursor: pointer;\r\n  background: var(--color-white);\r\n}\r\n\r\n.insight-card:hover {\r\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.insight-card .card-body { padding: 12px; }\r\n\r\n.ticket-link { color: var(--color-primary-green); font-weight: 600; font-size: 13px; text-decoration: none; }\r\n.ticket-link:hover { text-decoration: underline; }\r\n.ticket-date { color: #999; font-size: 11px; }\r\n.ticket-title { font-size: 13px; color: #333; margin-bottom: 8px; font-weight: 500; }\r\n.ticket-meta { display: flex; gap: 12px; font-size: 11px; color: #666; }\r\n.meta-item strong { color: #333; }\r\n\r\n.view-more-btn {\r\n  width: 100%;\r\n  padding: 10px;\r\n  background-color: var(--color-bg-hover);\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 6px;\r\n  color:var(--color-primary-green);\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-top: 8px;\r\n}\r\n.view-more-btn:hover { background-color: #e9ecef; border-color:var(--color-primary-green); }\r\n.view-more-btn i { font-size: 12px; }\r\n\r\n/* ── Workflow Tabs ── */\r\n.workflow-tab-hdr {\r\n  border-bottom: 2px solid #e5e7eb;\r\n  background: var(--color-white);\r\n  padding: 0 20px 0 0;\r\n}\r\n\r\n.workflow-tab {\r\n  width: 233px;\r\n  padding: 10px 20px;\r\n  background: transparent;\r\n  border: none;\r\n  color: #6b7280;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  position: relative;\r\n  transition: all 0.3s ease;\r\n  border-bottom: 3px solid transparent;\r\n  font-family: inherit;\r\n  display: flex;\r\n}\r\n.workflow-tab:hover { color: var(--color-primary-orange); background: #fff7ed; }\r\n.workflow-tab.selected { color: var(--color-primary-orange); border-bottom-color: var(--color-primary-orange); background-color: #f8e7d8ff; }\r\n\r\n.workflow-overflow-dots {\r\n  color:var(--color-primary-orange);\r\n  cursor: pointer;\r\n  font-size: 20px;\r\n  padding: 6px 10px;\r\n  user-select: none;\r\n  margin-left: -20px;\r\n}\r\n.workflow-overflow-dots:hover { background-color: #fff7ed; }\r\n\r\n/* ── Table hover ── */\r\n.table tbody tr { transition: background-color 0.2s ease, box-shadow 0.2s ease; }\r\n.table tbody tr:hover {\r\n  background-color: rgba(255, 127, 14, 0.06);\r\n  box-shadow: inset 4px 0 0 var(--color-primary-orange);\r\n}\r\n\r\n/* ── Cell alignment ── */\r\n.cell-center-align { display: flex !important; justify-content: center !important; align-items: center !important; }\r\n.cell-left-align { display: flex !important; justify-content: flex-start !important; align-items: center !important; }\r\n\r\n/* ── Custom scrollbar ── */\r\n.custom-scrollbar::-webkit-scrollbar { width: 1px; }\r\n.custom-scrollbar::-webkit-scrollbar-track { background: var(--color-white); }\r\n.custom-scrollbar::-webkit-scrollbar-thumb { background-color: #bdbdbd; border-radius: 10px; }\r\n.custom-scrollbar::-webkit-scrollbar-thumb:hover { background-color: #9e9e9e; }\r\n.custom-scrollbar { scrollbar-width: thin; }\r\n\r\n.insight-cards::-webkit-scrollbar { width: 6px; }\r\n.insight-cards::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 10px; }\r\n.insight-cards::-webkit-scrollbar-thumb { background: #888; border-radius: 10px; }\r\n.insight-cards::-webkit-scrollbar-thumb:hover { background: #555; }\r\n\r\n/* ── Animations ── */\r\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\r\n@keyframes slideInRight { from { transform: translateX(100%); } to { transform: translateX(0); } }\r\n\r\n@media (max-width: 768px) {\r\n  .side-panel { width: 100%; }\r\n}\r\n/* ── Internal Notes ── */\r\n.note-section-title {\r\n  font-weight: 600;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.note-show-toggle {\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  color: var(--color-icon-muted);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 13px;\r\n}\r\n\r\n.note-toggle-icon {\r\n  font-size: 12px;\r\n}\r\n\r\n.note-row {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n  padding: 10px 8px;\r\n  position: relative;\r\n}\r\n\r\n.note-meta {\r\n  min-width: 160px;\r\n  max-width: 160px;\r\n}\r\n\r\n.note-author {\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.note-time {\r\n  font-size: 12px;\r\n  color: var(--color-icon-muted);\r\n}\r\n\r\n.note-eye-wrap {\r\n  padding-top: 2px;\r\n  position: relative;\r\n}\r\n\r\n.note-eye-icon {\r\n  color: var(--color-primary-orange);\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n}\r\n\r\n.note-text-clamp {\r\n  flex: 1;\r\n  font-size: 13px;\r\n  color: #212529;\r\n  line-height: 1.5;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Note Tooltip */\r\n.note-tooltip {\r\n  position: absolute;\r\n  z-index: 1050;\r\n  bottom: calc(100% + 10px);\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 340px;\r\n  background: #f0fafa;\r\n  border: 1px solid var(--color-primary-green);\r\n  border-left: 4px solid var(--color-primary-green);\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 20px rgba(10, 118, 116, 0.15);\r\n  padding: 16px;\r\n}\r\n\r\n.note-tooltip-arrow-border {\r\n  position: absolute;\r\n  bottom: -8px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 8px solid transparent;\r\n  border-right: 8px solid transparent;\r\n  border-top: 8px solid var(--color-primary-green);\r\n}\r\n\r\n.note-tooltip-arrow {\r\n  position: absolute;\r\n  bottom: -6px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 8px solid transparent;\r\n  border-right: 8px solid transparent;\r\n  border-top: 8px solid #f0fafa;\r\n}\r\n\r\n.note-tooltip-name {\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.note-tooltip-date {\r\n  font-size: 12px;\r\n  color: var(--color-icon-muted);\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.note-tooltip-divider {\r\n  margin: 8px 0;\r\n}\r\n\r\n.note-tooltip-body {\r\n  font-size: 13px;\r\n  color: #212529;\r\n  line-height: 1.6;\r\n  white-space: pre-line;\r\n  word-break: break-word;\r\n}\r\n\r\n.note-tooltip-updated {\r\n  font-size: 11px;\r\n  color: #adb5bd;\r\n  margin-top: 10px;\r\n}\r\n.note-table {\r\n  border: 1px solid #495057;\r\n  border-radius: 8px;\r\n  overflow: visible;\r\n}\r\n\r\n.note-row {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n  padding: 10px 8px;\r\n  position: relative;\r\n  border-bottom: 1px solid #e9ecef;\r\n}\r\n\r\n.note-row:first-child {\r\n  border-radius: 8px 8px 0 0;  /* keeps rounded corners on first row */\r\n}\r\n\r\n.note-row:last-child {\r\n  border-bottom: none;\r\n  border-radius: 0 0 8px 8px;  /* keeps rounded corners on last row */\r\n}\r\n\r\n/* ── CC Recipients Column ── */\r\n.cc-recipients {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.cc-badge {\r\n  transition: all 0.2s ease;\r\n  user-select: none;\r\n}\r\n\r\n.cc-badge:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Responsive: Hide CC column on mobile */\r\n@media (max-width: 768px) {\r\n  .cc-column {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* Tablet: Show CC column but with smaller width */\r\n@media (min-width: 769px) and (max-width: 1024px) {\r\n  th.cc-column,\r\n  td.cc-column {\r\n    width: 140px !important;\r\n  }\r\n}\r\n@media (max-width: 768px) {\r\n  .detailsPageHeader {\r\n    flex-wrap: wrap;\r\n    row-gap: 8px;\r\n  }\r\n\r\n  .detailsPageHeader .dropdown-toggle {\r\n    width: 100% !important;\r\n  }\r\n\r\n  .detailsPageHeader .dropdown-menu {\r\n    width: 100% !important;\r\n  }\r\n\r\n  .detailsPageHeader > .col-md-3 {\r\n    max-width: 100%;\r\n    flex: 1 1 100%;\r\n    order: 2;\r\n  }\r\n\r\n  .detailsPageHeader > [class*=\"gx-0\"] {\r\n    flex: 1 1 auto;\r\n    order: 3;\r\n  }\r\n\r\n  .detailsPageHeader .default-btn-color {\r\n    width: 100%;\r\n    white-space: nowrap;\r\n  }\r\n}\r\n@media (max-width: 768px) {\r\n  .detailsPageHeader .col.d-flex.justify-content-between {\r\n    flex-direction: column;\r\n    align-items: stretch !important;\r\n    gap: 8px;\r\n  }\r\n\r\n  .detailsPageHeader .breadcrumb-wrapper {\r\n    width: 100%;\r\n    order: 1;\r\n  }\r\n\r\n  .detailsPageHeader .header-actions {\r\n    width: 100%;\r\n    justify-content: flex-end;\r\n    order: 2;\r\n  }\r\n}\r\n@media (max-width: 768px) {\r\n  .detailsPageHeader {\r\n    padding-left: 12px !important;\r\n    padding-right: 12px !important;\r\n  }\r\n\r\n  .detailsPageHeader .col-auto {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .detailsPageHeader .col-auto .gx-0 {\r\n    margin-right: 6px !important;\r\n    margin-bottom: 6px;\r\n  }\r\n\r\n  .detailsPageHeader button,\r\n  .detailsPageHeader .btn {\r\n    margin: 0 4px 6px 0 !important;\r\n  }\r\n}\r\n .ticket-selected-badge {\r\n  background: var(--primary);\r\n  color: var(--primary-text);\r\n  border-radius: 20px;\r\n  padding: 2px 10px;\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  white-space: nowrap;\r\n}\r\n/* ── Orange link icons (SAP/District/Region/Company) ── */\r\n.location-link-icon {\r\n  color: var(--color-primary-green);\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* ── Store Visit text link ── */\r\n.store-visit-link {\r\n  font-size: 12px;\r\n  color: var(--color-primary-orange);\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* ── Employee search external-link round button ── */\r\n.emp-search-btn {\r\n  height: 24px;\r\n  width: 24px;\r\n  border-radius: 50%;\r\n  background: var(--color-primary-green);\r\n  border: none;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n.avatar-circle {\r\n  width: 42px;\r\n  height: 42px;\r\n  border-radius: 50%;\r\n  background: #0bb5d4;\r\n  color: var(--color-white);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  flex-shrink: 0;\r\n}\r\n.message-bubble {\r\n  max-width: 75%;\r\n  padding: 15px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 1px 3px rgba(0,0,0,0.08);\r\n}\r\n\r\n.message-bubble--me {\r\n  background: #d1f8ff;\r\n  border: 2px solid #0bb5d4;\r\n}\r\n\r\n.message-bubble--other {\r\n  background: #f1f1f1;\r\n  border: 2px solid #ddd;\r\n}\r\n.eye-icon {\r\n  color: var(--color-primary-orange);\r\n}\r\n\r\n.attachment-badge {\r\n  background-color: rgba(10, 118, 116, 0.12);\r\n  color: var(--color-primary-green);\r\n  font-weight: 600;\r\n  border-radius: 12px;\r\n  padding: 4px 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n.history-table-header {\r\n  color: var(--color-primary-orange);\r\n}\r\n.insight-header-icon {\r\n  color: var(--color-primary-orange);\r\n  font-size: 20px;\r\n}\r\n\r\n.insight-close-btn {\r\n  background-color: var(--color-primary-orange);\r\n  color: var(--color-white);\r\n}\r\n\r\n.insight-section-icon {\r\n  color: var(--color-primary-orange);\r\n}\r\n.workflow-arrow-icon {\r\n  color: var(--color-primary-orange);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
